import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAdminData } from "../../context/AdminDataContext";
import BuildingsWithFlatReadings from "./BuildingsWithFlatReadings";

const AdminBuildingsPage = () => {
  const { t } = useTranslation();
  const { flatReadings, loading, error } = useAdminData();
  const [viewMode, setViewMode] = useState("table");

  if (loading) {
    return <p className="text-gray-600">{t("admin_loading_data")}</p>;
  }
  if (error) {
    return (
      <p className="text-red-600">
        {t("admin_error")}: {error}
      </p>
    );
  }

  return (
    <BuildingsWithFlatReadings
      flatReadings={flatReadings}
      viewMode={viewMode}
      setViewMode={setViewMode}
    />
  );
};

export default AdminBuildingsPage;
